import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './plugins/store'
import router, { routes } from './router'
import TopBar from '@/components/TopBar'
import AccountManager from '@/components/AccountManager'
import moment from 'moment'
import sift from 'sift'
import { mapGetters } from 'vuex'

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.mixin({
  components: {
    TopBar,
    AccountManager
  },
  methods: {
    // Convert int unix timestamp in seconds to a formatted date
    $timestamp (seconds, format = 'll') {
      const m = moment.unix(seconds)
      return m.format(format)
    }
  }
});

(async () => {
  store.dispatch('getSession')

  new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
    computed: {
      ...mapGetters(['user']),
      $restrictionObject () {
        return {
          user: this.user
        }
      },
      menuItems () {
        if (this.user) {
          return routes.filter(route =>
            route &&
            route.meta &&
            route.meta.nav &&
            (
              !(route && route.meta && route.meta.restrict) ||
              this.$restrict(route.meta.restrict)
            )
          )
        }
        return []
      }
    },
    methods: {
      // Returns true if passes restriction
      $restrict (query) {
        return [this.$restrictionObject].filter(sift(query)).length > 0
      }
    }
  }).$mount('#app')
})()
